import React, { Component } from "react";
const FAREWELL_SUBTYPE_CODE = "ST080";

class ChildLetterTile extends Component {
  render() {
    const { mediaData, childData = {}, isCommunity } = this.props;
    const { url: mediaUrl, subtypeCode } = mediaData;
    const { givenName = "this child" } = childData;
    if (!mediaUrl) {
      return null;
    }

    const letterText =
      {
        [FAREWELL_SUBTYPE_CODE]: `A farewell letter from ${givenName} is here!`,
      }[subtypeCode] || `A letter from ${givenName} is here!`;
    const letterType = isCommunity
      ? {
          media_title: "Community Update",
          letter_text: "A new letter from your sponsored child's community manager!",
          imgUrl: "https://wvusstatic.com/2020/svg-icons/mail-letter-icon.svg",
          community_img_class: "community-letter"
        }
      : {
          media_title: "Child's Letter",
          letter_text: letterText,
          imgUrl: "https://wvusstatic.com/mywv/msc-past/letter-in-envelope.svg",
          community_img_class:""
        };
    return (
      <div className="tile sg-tile tile--child-letter">
        <p className="tile__title gallery__heading">
          <i className="fa fa-envelope-o" aria-hidden="true"></i> {letterType.media_title}
        </p>
        <div className={`img-container ${letterType.community_img_class}`}>
          <img src={letterType.imgUrl} height="130" width="150" />
        </div>
        <p className="tile__caption gallery__description deci">{letterType.letter_text}</p>
        <a className="btn btn-small btn-text btn-text-orange" href={mediaUrl} target="_blank" rel="noopener noreferrer">
          Download letter <i className="fa fa-angle-right" aria-hidden="true"></i>
        </a>
      </div>
    );
  }
}

export default ChildLetterTile;
